export interface CHCHeaderProps {
    src?: string
}

export const CHCHeader = (props: CHCHeaderProps) => {
    const {src} = props;

    const containerStyle : React.CSSProperties = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        width:'100vw',
        color: 'white',
      }
    
      const headerStyle : React.CSSProperties = {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent:'space-evenly',
        background: 'rgb(18,25,101)',
        borderTop: 'solid 2px rgba(245,0,0,.5)',
        borderBottom: 'solid 2px rgba(245,0,0,.5)',
        color: 'white'
      }

  return (
    <div style={containerStyle}>

      <div style={headerStyle}>
        {/* LOGO */}
        <div style={{display: 'flex', flexDirection:'column', justifyContent:'space-evenly', flex:'1 3', margin:'.5%'}}>
      
          <div style={{display: 'flex', flexDirection:'row', justifyContent:'space-evenly'}}>
            <img width={200} src={src} alt="CHC Logo"/>
          </div>
      
        </div>
      </div>
    </div>)
}